import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDynamicConfig, useStatsigClient } from '@statsig/react-bindings';
import "./LinkCard.scss";
import Tooltip from "../Tooltip";

import NewTabIcon from "@/assets/icons/NewTab.svg";
import LineIcon from "@/assets/icons/line.svg";
import { AI_ASSISTANT_CONSTANTS } from "../../constants/aiAssistantConstants";

const LinkCard = ({ title, description, link }) => {
    const navigate = useNavigate();
    const { client } = useStatsigClient();
    const config = useDynamicConfig(AI_ASSISTANT_CONSTANTS.DYNAMIC_CONFIGS.AI_ASSISTANT_CONFIGS);

    const handleInternalNavigation = useCallback((e) => {
        if (e) e.stopPropagation();
        if (!link) return;
        try {
            if (link.startsWith("http")) {
                const url = new URL(link);
                const isSameOrigin = url.origin === window.location.origin;
                if (isSameOrigin) {
                    sessionStorage.setItem("params", url.search);
                    navigate(url.pathname + url.search);
                } else {
                    window.location.href = link;
                }
            } else {
                navigate(link);
            }
        } catch (error) {
            navigate(link);
        }
    }, [link, navigate]);

    const handleExternalClick = (e) => {
        e.stopPropagation();
        window.open(link, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="link-card" onClick={handleExternalClick}>
            <div className="left-section">
                <div className="icon-wrapper">
                    <img src={LineIcon} alt="Icon" className="icon" />
                </div>
                <div className="text-content">
                    <div className="title">{title}</div>
                    <div
                        className="description"
                        onClick={handleExternalClick}
                    >
                        {description}
                    </div>
                </div>
            </div>
            <div className="right-section">
                <Tooltip content="Open in new tab" placement="top" arrow={true} variant="light">
                    <img
                        src={NewTabIcon}
                        alt="Open in new tab"
                        className="action-icon"
                        onClick={handleExternalClick}
                    />
                </Tooltip>
            </div>
        </div>
    );
};

export default LinkCard;
